<script lang="ts">
  export let summary;

  let visible = false;
</script>

<div class="row" style="background-color: #F1F3F6;">
  <div class="col mb-2">
    <div class="pt-3">
      <div>
        <h2>Collection Description</h2>
      </div>
      <div>
        {#if !visible}
          <p class="lead" id="collection-description">
            {summary.slice(0, 600)}...
          </p>
        {:else}
          <p class="lead" id="collection-description">
            {summary}
          </p>
        {/if}
        <button
          class="btn ae-primary my-2 read-more-btn"
          id="readMore"
          type="button"
          aria-controls="collection-description"
          aria-expanded={visible}
          aria-label={visible
            ? "Show less collection description"
            : "Show full collection description"}
          on:click={() => {
            visible = !visible;
          }}
        >
          {#if !visible}
            Read more
          {:else}
            Read less
          {/if}
        </button>
      </div>
    </div>
  </div>
</div>

<style>
  .read-more-btn:focus {
    outline: 2px solid #0066cc;
    outline-offset: 2px;
    box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.2);
  }

  .read-more-btn:focus-visible {
    outline: 2px solid #0066cc;
    outline-offset: 2px;
    box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.2);
  }
</style>
